const backendDomain = 'https://backend.dalel.sa';

export const environment = {
  production: true,
  backendDomain: backendDomain,
  apiUrl: `${backendDomain}/api/public`,
  imagesUrl: `${backendDomain}/storage/images/users-images/`,
  mediaUrl: `${backendDomain}/storage/`,
  socialUrl: `${backendDomain}/storage/images/social-icons/`,
  categoryUrl: `${backendDomain}/storage/images/categories-images/`,
  service_imgUrl: `${backendDomain}/storage/images/services-images/`,
  FileMangerPath: `${backendDomain}/laravel-filemanager`,
  GoogleMapsApiKey: 'AIzaSyBJd_eZsuo34ZWZw78WBWEUyL0ngq5caWU',
};